import ItemsTemplate from "./ItemsTemplate";
import React from "react";
import { DragOverlay, useDndContext } from "@dnd-kit/core";

const fieldStyle: React.CSSProperties = {
    backgroundColor: "rgba(22, 119, 255, 0.8)",
    padding: "20px",
    color: "white",
    borderRadius: "5px",
    fontSize: "14px",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backdropFilter: "blur(1px)",
    width: 250,
    border: "1px solid white",
    boxShadow: "0 5px 15px 5px rgb(0 0 0 / 40%)",
};

// DragOverlay handles positioning automatically
export function ItemsDragLayer() {
    // Use DndContext to get information about the current drag operation
    const { active } = useDndContext();

    return active ? (
        <DragOverlay>
            <div style={fieldStyle}>
                <ItemsTemplate />
            </div>
        </DragOverlay>
    ) : undefined;
    // <div id={"helloooo"} style={{ position: "fixed", top: 50, left: 50, zIndex: 10000, width: 500, height: 500 }}>
    //     <div style={fieldStyle}>
    //         <ItemsTemplate />
    //     </div>
    // </div>
}
